import ReactTooltip from 'react-tooltip';
import React from 'react';
import { FlexiflowComponent } from '@flexiflow-ui-kit/system';
import styled from 'styled-components';

function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var _templateObject;
var OverlayContainer = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  && {\n    ", ";\n    z-index: 1000;\n\n    .__react_component_tooltip {\n      max-width: ", "px;\n      white-space: normal;\n      word-break: break-word;\n      padding: 12px 25px 12px 12px;\n      font-size: 14px;\n      font-weight: normal;\n      line-height: 16px;\n      border-radius: 4px;\n      background-color: ", ";\n      border-color: ", ";\n      opacity: 1;\n    }\n    .place-bottom::after {\n      border-bottom-color: ", ";\n      border-bottom-width: 10px;\n    }\n    .place-top::after {\n      border-top-color: ", ";\n      border-top-width: 10px;\n    }\n    .place-left::after {\n      border-right-color: ", ";\n      border-right-width: 10px;\n    }\n    .place-right::after {\n      border-left-color: ", ";\n      border-left-width: 10px;\n    }\n  }\n"])), function (p) {
  return p.theme.predefinedCss.borderBoxChildren;
}, function (p) {
  return p.maxWidth;
}, function (p) {
  return p.theme.palette.black;
}, function (p) {
  return p.theme.palette.black;
}, function (p) {
  return p.theme.palette.black;
}, function (p) {
  return p.theme.palette.black;
}, function (p) {
  return p.theme.palette.black;
}, function (p) {
  return p.theme.palette.black;
});

var _excluded = ["children", "maxWidth", "className", "offset", "place"];
function Tooltip(_ref) {
  var children = _ref.children,
      _ref$maxWidth = _ref.maxWidth,
      maxWidth = _ref$maxWidth === void 0 ? 300 : _ref$maxWidth,
      className = _ref.className;
      _ref.offset;
      var _ref$place = _ref.place,
      place = _ref$place === void 0 ? 'bottom' : _ref$place,
      otherProps = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement(FlexiflowComponent, null, /*#__PURE__*/React.createElement(OverlayContainer, {
    maxWidth: maxWidth
  }, /*#__PURE__*/React.createElement(ReactTooltip, _extends({
    className: className,
    clickable: true,
    resizeHide: false,
    scrollHide: false,
    isCapture: false,
    place: place,
    effect: "solid",
    multiline: true,
    delayHide: 100
  }, otherProps), children)));
}

export { Tooltip };
